/**
 * A custom element that manages the account login actions.
 *
 * @extends {HTMLElement}
 */
class AccountLoginActions extends HTMLElement {
  /**
   * @type {Element | null}
   */
  shopLoginButton = null;

  connectedCallback() {
    this.shopLoginButton = this.querySelector('shop-login-button');

    if (this.shopLoginButton) {
      // We don't have control over the shop-login-button markup, so we need to set additional attributes here
      this.shopLoginButton.setAttribute('full-width', 'true');
      this.shopLoginButton.setAttribute('persist-after-sign-in', 'true');
      // Do this only if New Customer Account is ALWAYS the sign in option (and never Classic Customer Account)
      this.shopLoginButton.setAttribute('analytics-context', 'loginWithShopSelfServe');
      this.shopLoginButton.setAttribute('flow-version', 'account-actions-popover');
      
      // Redirect to homepage after login (preserve country parameter if exists)
      const redirectUrl = this.getRedirectUrl();
      this.shopLoginButton.setAttribute('return-uri', redirectUrl);

      // Reload the page after the login is completed
      this.shopLoginButton.addEventListener('completed', () => {
        // Redirect to homepage to avoid persisting any editor parameters
        window.location.href = redirectUrl;
      });
    }
  }

  /**
   * Get the redirect URL after login - homepage with country parameter if it exists
   * @returns {string} - Clean homepage URL with country parameter
   */
  getRedirectUrl() {
    const currentUrl = new URL(window.location.href);
    const country = currentUrl.searchParams.get('country');
    
    // Build homepage URL
    const homepageUrl = new URL(window.location.origin);
    
    // Preserve country parameter if it exists
    if (country) {
      homepageUrl.searchParams.set('country', country);
    }
    
    return homepageUrl.toString();
  }
}

if (!customElements.get('account-login-actions')) {
  customElements.define('account-login-actions', AccountLoginActions);
}
